import React, { createContext, useContext, useState, useEffect } from "react";
import { BASE_API_URL } from "../utils/app-constants";
import axios from "axios";
import { toast } from "react-toastify";

export const CartContext = createContext({});

export function CartProvider(props) {
  const [items, setItems] = useState([]);
  const [isSelfCollection, setIsSelfCollection] = useState(false);
  const [coupon, setCoupon] = useState(null);
  const [deepFryCost, setDeepFryCost] = useState(0);

  useEffect(() => {
    axios
      .get(`${BASE_API_URL}public/settings`)
      .then((res) => {
        const setting = res.data?.returned_resultset?.find(
          (s) => s.key === "DEEP_FRIED",
        );
        if (setting) setDeepFryCost(parseFloat(setting.value));
      })
      .catch((err) => console.error("Unable to fetch deep fry cost", err));
  }, []);

  console.log(coupon, "cp");

  function addItemToCart(product, qty) {
    setItems((prevItems) => {
      const item = prevItems.find(
        (item) => item.product.id == product.id && !item.deep_fried,
      );
      if (!item) {
        return [
          ...prevItems,
          {
            qty: qty ? qty : 1,
            product,
            deep_fried: false,
            discountedTotal: product?.discounted_price?.toFixed(0) * qty,
            totalPrice: product.unit_value * qty,
            deep_fried: false,
          },
        ];
      } else {
        return prevItems.map((item) => {
          if (item.product.id == product.id && !item.deep_fried) {
            item.qty = qty;
            item.totalPrice = product.unit_value * qty;
            item.discountedTotal = product?.discounted_price * qty;
          }
          return item;
        });
      }
    });
    toast.success("Item added to basket");
  }
  function setDeepFriedQuantity(productId, friedQty) {
    setItems((prevItems) => {
      const regularItem = prevItems.find(
        (i) => i.product.id === productId && !i.deep_fried,
      );
      const friedItem = prevItems.find(
        (i) => i.product.id === productId && i.deep_fried,
      );
      const totalQty = (regularItem?.qty || 0) + (friedItem?.qty || 0);
      const clampedFriedQty = Math.max(0, Math.min(friedQty, totalQty));
      const regularQty = totalQty - clampedFriedQty;
      const product = regularItem?.product || friedItem?.product;
      if (!product) return prevItems;

      const otherItems = prevItems.filter((i) => i.product.id !== productId);
      const newLines = [];
      if (regularQty > 0) {
        newLines.push({
          qty: regularQty,
          product,
          deep_fried: false,
          totalPrice: product.unit_value * regularQty,
          discountedTotal: product?.discounted_price
            ? product.discounted_price * regularQty
            : undefined,
        });
      }
      if (clampedFriedQty > 0) {
        newLines.push({
          qty: clampedFriedQty,
          product,
          deep_fried: true,
          totalPrice: product.unit_value * clampedFriedQty,
          discountedTotal: product?.discounted_price
            ? product.discounted_price * clampedFriedQty
            : undefined,
        });
      }
      return [...otherItems, ...newLines];
    });
  }
  function toggleDeepFried(productId) {
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.product.id === productId
          ? { ...item, deep_fried: !item.deep_fried }
          : item,
      ),
    );
  }

  function removeItem(id) {
    return setItems(() => items?.filter((item) => item?.product.id !== id));
  }

  function updateCartItem(updateditems) {
    setItems(() => updateditems);
  }
  function getDeepFryFee() {
    return items
      .filter((item) => item.deep_fried)
      .reduce((sum, item) => sum + item.qty * deepFryCost, 0);
  }
  function getItemsCount() {
    return items.length;
  }

  function getTotalPrice() {
    const itemsTotal = items.reduce(
      (sum, item) => sum + (item?.discountedTotal || item.totalPrice),
      0,
    );
    const deliveryFee = isSelfCollection ? 0 : itemsTotal < 4000 ? 400 : 0;
    return itemsTotal + getDeepFryFee() + deliveryFee;
  }

  return (
    <CartContext.Provider
      value={{
        items,
        setItems,
        getItemsCount,
        addItemToCart,
        getTotalPrice,
        updateCartItem,
        removeItem,
        toggleDeepFried,
        getDeepFryFee,
        deepFryCost,
        setDeepFriedQuantity,
        setIsSelfCollection,
        isSelfCollection,
        coupon,
        setCoupon,
      }}
    >
      {props.children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
